/* eslint-disable */
import React from 'react';
import './styles/Services.css';

const Services = () => {
  const services = [
    {
      icon: '🎓',
      title: 'Training & Mentorship',
      description: 'Comprehensive capacity building programs for health professionals and rapid response teams.',
      features: ['Workshops', 'Simulation Exercises', 'Technical Training'],
      color: '#2c5aa0'
    },
    {
      icon: '💉',
      title: 'Vaccination Programs',
      description: 'Public health vaccination initiatives and immunization campaigns across South Sudan.',
      features: ['Routine Immunization', 'Mass Vaccination', 'Cold Chain Management'],
      color: '#27ae60'
    },
    {
      icon: '📢',
      title: 'RCCE',
      description: 'Risk Communication and Community Engagement for effective public health messaging.',
      features: ['Community Outreach', 'Health Education', 'Behavior Change Communication'],
      color: '#e74c3c'
    },
    {
      icon: '🌍',
      title: 'One Health Events',
      description: 'Coordination and celebration of international One Health days and awareness campaigns.',
      features: ['World One Health Day', 'Rabies Day', 'Zoonosis Awareness'],
      color: '#9b59b6'
    },
    {
      icon: '🚨',
      title: 'Emergency Preparedness',
      description: 'Response planning and capacity building using integrated One Health approaches.',
      features: ['Contingency Planning', 'Rapid Response', 'Emergency Coordination'],
      color: '#e67e22'
    },
    {
      icon: '🔬',
      title: 'Joint Outbreak Deployment',
      description: 'Multi-sectoral outbreak investigation and response teams deployment.',
      features: ['Field Investigations', 'Laboratory Support', 'Multi-sectoral Teams'],
      color: '#34495e'
    },
    {
      icon: '📊',
      title: 'Research & Analytics',
      description: 'Operational research and data analysis to inform policy and practice.',
      features: ['Epidemiological Studies', 'Policy Research', 'Data Analysis'],
      color: '#16a085'
    }
  ];

  return (
    <div className="services-page" id='services-page'>
      <section className="page-header">
        <div className="container">
          <div className="page-header-content">
            <h1>Our Services</h1>
            <p className="page-subtitle">
              Comprehensive health security services protecting communities across South Sudan
            </p>
          </div>
        </div>
      </section>

      <section className="services-grid-section" id='services-grid'>
        <div className="container">
          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className="service-card">
                <div 
                  className="service-icon" 
                  style={{ backgroundColor: `${service.color}20`, color: service.color }}
                >
                  <span>{service.icon}</span>
                </div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <div className="service-features">
                  {service.features.map((feature, idx) => (
                    <span key={idx} className="feature-tag">{feature}</span>
                  ))}
                </div>
                <button className="service-btn">Learn More</button>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="online-portal-section">
        <div className="container">
          <div className="portal-header">
            <h2>Online Service Portal</h2>
            <p>Access our digital services and resources</p>
          </div>
          <div className="portal-grid">
            <div className="portal-card">
              <div className="portal-icon">📝</div>
              <h4>Service Applications</h4>
              <p>Submit requests and access application forms</p>
              <button className="portal-btn">Access Forms</button>
            </div>
            <div className="portal-card">
              <div className="portal-icon">📋</div>
              <h4>Service Standards</h4>
              <p>View our service standards and turnaround times</p>
              <button className="portal-btn">View Standards</button>
            </div>
            <div className="portal-card">
              <div className="portal-icon">❓</div>
              <h4>FAQs & Support</h4>
              <p>Find answers to frequently asked questions</p>
              <button className="portal-btn">Get Help</button>
            </div>
            <div className="portal-card">
              <div className="portal-icon">📞</div>
              <h4>Contact Support</h4>
              <p>Get in touch with our service desk</p>
              <button className="portal-btn">Contact Us</button>
            </div>
          </div>
        </div>
      </section>
      <section className="service-stats">
        <div className="container">
          <h2>Service Impact</h2>
          <div className="stats-cards">
            <div className="stat-item">
              <div className="stat-number">500+</div>
              <div className="stat-label">Health Workers Trained</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">1M+</div>
              <div className="stat-label">Vaccines Administered</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">50+</div>
              <div className="stat-label">Outbreaks Managed</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">100+</div>
              <div className="stat-label">Communities Served</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;